// extracted by mini-css-extract-plugin
export default {"page":"SettingsPage_page__Bb+WM","pageName":"SettingsPage_pageName__JfeSk"};